export class ProviderItemModel {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}
